import React from 'react';
import { InteractiveShape } from '../interactive/InteractiveShape';
import appParameters from '../../utils/AppParameters';
import previewCommands from '../../utils/PreviewCommands';
import {addVideoShapeDuration, selectShape} from "../../../actions/CurrentSlideActions";
import storeManager from "../../../store/StoreManager";
import videoUtils from "../../utils/VideoUtils";
import locales from "../../../locales/LocalesManager";
import platformDetection from "../../utils/PlatformDetection";
import {hideMenus, setContextTarget} from "../../../actions/MenuActions";
import menuType from "../../../constants/MenuType";
import mouseUtils from "../../utils/MouseUtils";

export const Video = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            isPlay: false,
            isLoaded: false
        };
    },
    componentWillReceiveProps(nextProps) {
        if (this.props.shapeModel.refresh != nextProps.shapeModel.refresh)
            this.forceUpdate();
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut (e) {
        if (e.relatedTarget && (e.relatedTarget === this.refs.playButton || e.relatedTarget === this.refs.buttonHolder))
            return;

        this.setState({
            isOver: false
        });
    },
    onVideoEnded() {
        if (this.refs.videoShape)
            this.refs.videoShape.currentTime = 0;

        this.setState({
            isPlay: false
        });
    },
    onPlayPause () {
        if (!this.refs.videoShape)
            return;

        if (this.state.isPlay === true)
            this.refs.videoShape.pause();
        else
            this.refs.videoShape.play();

        this.setState({
            isPlay: !this.state.isPlay
        });
    },
    onVideoLoaded () {
        if (previewCommands.isPlayMode() || !this.refs.videoShape || this.state.isLoaded)
            return;

        var duration = this.refs.videoShape.duration;

        if (duration > 0) {
            this.setState({
                isLoaded: true
            });

            videoUtils.checkSlideDurationWhenAddVideoShape(duration);
            storeManager.getStore().dispatch(addVideoShapeDuration(this.props.shapeModel, duration));
        }
    },
    isShapeSelected() {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var i;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].uuid == this.props.shapeModel.uuid) {
                if (shapes[i].isSelected == true)
                    return true;
                else
                    return false;
            }

        return false;
    },
    onKeyDown(e) {
        if (e.keyCode == 13) { // ENTER
            setTimeout(function() {
                this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
                this.props.dispatch(setContextTarget(this.props.shapeModel));

                setTimeout(function() {
                    var buttonMenu = document.getElementById('shapeMenuFirstElement');

                    if (buttonMenu)
                        buttonMenu.focus();
                }.bind(this), 20);
            }.bind(this), 20);
        }
    },
    onFocusHandler() {
        if (document.activeElement == this.refs.focusableElement) {
            if (!this.isShapeSelected())
                this.props.dispatch(selectShape(this.props.shapeModel.uuid));

            mouseUtils.activeElement = this.props.shapeModel.uuid;
        }
    },
    render() {
        const { shapeModel, dispatch } = this.props;
        const playHolderSize = 26;

        const playHolder = {
            position: 'absolute',
            width: playHolderSize,
            height: playHolderSize,
            cursor: '-webkit-grab',
            background: 'white',
            borderRadius: 4,
            border: 'none'
        };

        const playBtn = {
            position: 'absolute',
            width: playHolderSize / 2,
            height: playHolderSize / 2,
            left: playHolderSize / 4,
            top: playHolderSize / 4
        };

        let icon;

        if (this.state.isPlay === true)
            icon = appParameters.RESOURCES_LOCATION() + 'assets/player/pause.png';
        else
            icon = appParameters.RESOURCES_LOCATION() + 'assets/player/play.png';

        let showPlayButton = false;

        if (previewCommands.isEditorMode() === false)
            showPlayButton = false;
        else {
            let videoIsPlaying = this.refs.videoShape && !!(this.refs.videoShape.currentTime >= 0 && !this.refs.videoShape.paused && !this.refs.videoShape.ended);

            if (videoIsPlaying) {
                showPlayButton = this.state.isOver;
            } else {
                showPlayButton = !shapeModel.isInteraction || (shapeModel.isInteraction && shapeModel.moveState);
            }
        }

        var playAriaLabel = '';

        if (this.state.isPlay)
            playAriaLabel = locales.getCaption('pause', 'audioRecorder');
        else
            playAriaLabel = locales.getCaption('play', 'audioRecorder');

        let videoX = 0;
        let videoY = 0;

        if (platformDetection.isIOS()) {
            showPlayButton = false;

            videoX = shapeModel.x;
            videoY = shapeModel.y;
        }

        let videoAriaLabel = 'Video'

        if (shapeModel.title && shapeModel.title.length > 0)
            videoAriaLabel = videoAriaLabel + ' - ' + shapeModel.title;

        return (
            <InteractiveShape shapeModel={shapeModel} dispatch={dispatch} scaleProperties={this.props.scaleProperties}>
                <g transform={`translate(${shapeModel.x} ${shapeModel.y})`} opacity={shapeModel.opacity}>
                    <g>
                        <foreignObject x={videoX} y={videoY} width={shapeModel.width} height={shapeModel.height}>
                            <video ref='videoShape' id={'videoShape_' + shapeModel.uuid} aria-label={videoAriaLabel} width={shapeModel.width} height={shapeModel.height} src={videoUtils.getCorrectUrl(shapeModel.xlinkHref)} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onEnded={this.onVideoEnded} onDurationChange={this.onVideoLoaded}/>
                        </foreignObject>

                        {
                            !shapeModel.isGrouped ?
                                <foreignObject>
                                    <a id={'interactiveElement_' + this.props.shapeModel.uuid} href='' ref='focusableElement' onFocus={this.onFocusHandler} onKeyDown={this.onKeyDown}></a>
                                </foreignObject >
                                : null
                        }

                        {showPlayButton ?
                            <foreignObject ref='buttonHolder' x={shapeModel.width/2 - playHolderSize/2} y={shapeModel.height/2 - playHolderSize/2} width={playHolderSize} height={playHolderSize}>
                                <button ref='playButton' style={playHolder} aria-label={playAriaLabel} onClick={this.onPlayPause} onTouchStart={this.onPlayPause}>
                                    <img style={playBtn} src={icon}></img>
                                </button>
                            </foreignObject> : null
                        }
                    </g>
                </g>
            </InteractiveShape>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/Video.js
 **/